/* eslint-disable no-param-reassign */
import axios from 'axios';
import store from '@/vuex/store';
import { getEnv } from '@/environment';

const isBrukerinfoEnabled = (config = {}) => {
  return Object.prototype.hasOwnProperty.call(config, 'useBrukerinfo') && !config.useBrukerinfo;
};

export default function setup() {
  axios.interceptors.request.use(
    async (request) => {
      await store.state.updateToken();

      if (isBrukerinfoEnabled()) {
        request.headers.brukerIdentifikator = store.state.brukerinfo.brukerId;
      } else {
        request.headers.brukerIdentifikator = store.state.representasjoner.currentRepresentation.identifikator;
      }

      request.headers['o-app-id'] = getEnv('VUE_APP_APPLICATION_ID'); // array access pga. bindestrek i header name
      request.headers.Authorization = `Bearer ${store.state.accessToken}`;

      return request;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
}
